import React, { useContext, useEffect, useMemo, useState } from "react";
import { Layout } from "antd";
import { Outlet, useLocation, useMatches } from "react-router-dom";
import Headers from "./StudentHeader";
import Footers from "../../../Footers";
import StudentPageHeader from "./StudentPageHeader";
import { Context } from "../../../Context";
import { StudentProvider, useStudent } from "./StudentContext";
import SessionTimeoutManager from "../../Common/SessionTimeoutManager";
import { COOKIE, getCookie } from "../../../services/cookie";

const { Content } = Layout;

const getChapterTitle = (chapterId, chapterName, chapterList = []) => {
	if (chapterName) return chapterName;
	const chapter = chapterList?.find(
		(item) => String(item?.chapter_id) === String(chapterId)
	);
	return chapter?.chapter_title || chapter?.chapter || "";
};

const StudentLayoutContent = () => {
	const [studentPageHeaderOverride, setStudentPageHeader] = useState({});
	const location = useLocation();
	const matches = useMatches();
	const { chapterList } = useContext(Context);
	const { setNavigationChapter } = useStudent();
	const currentRoute = matches[matches.length - 1];
	const routeHandle = currentRoute?.handle;
	const state = location.state || {};

	const chapterId = studentPageHeaderOverride?.chapterId || state?.chapter_id;
	const chapterName = getChapterTitle(
		chapterId,
		studentPageHeaderOverride?.chapterName || state?.chapter_name,
		chapterList
	);

	const studentPageHeader = useMemo(() => ({
		showChapterBlock: Boolean(routeHandle?.chapterHeader?.show && chapterId),
		showBreadcrumbs: routeHandle?.chapterHeader?.showBreadcrumbs !== false && Boolean(routeHandle?.breadcrumb),
		chapterId,
		chapterName,
	}), [chapterId, chapterName, routeHandle]);

	useEffect(() => {
		if (location.pathname === "/dashboard") {
			setNavigationChapter(null);
			return;
		}

		if (state?.chapter_id) {
			setNavigationChapter({
				chapterId: state.chapter_id,
				chapterName,
			});
			return;
		}

		setNavigationChapter(null);
	}, [chapterName, location.pathname, setNavigationChapter, state?.chapter_id]);

	return (
		<>
			<StudentPageHeader header={studentPageHeader} />
			<Outlet context={{ setStudentPageHeader }} />
		</>
	);
};

const Layouts = () => {
	const [token, setToken] = useState(null);
	useEffect(() => {
		const interval = setInterval(() => {
			const storedToken = getCookie(COOKIE.Token);

			if (storedToken) {
				setToken(storedToken);
				clearInterval(interval);
			}
		}, 500);

		return () => clearInterval(interval);
	}, []);
	return (
		<Layout className="!bg-white">
			{token && (
				<SessionTimeoutManager userType="student" />
			)}
			<Headers />
			<Content className="min-h-[82vh] py-6 px-2 lg:px-0">
				<StudentProvider>
					<StudentLayoutContent />
				</StudentProvider>
			</Content>
			<Footers />
		</Layout>
	);
};

export default Layouts;
